import React, { Component } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{this.props.children}</>)
  }
}

const PrevArrow = ({ onClick, style, className }) => {
  let attr = { onClick, style, className }
  return (
    <span
      {...attr}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="10.625" height="20" viewBox="0 0 10.625 20">
        <path d="M9.342-31.777.216-22.527a.751.751,0,0,0,0,1.054l9.126,9.25a.749.749,0,0,0,1.06.007.751.751,0,0,0,.007-1.061L1.8-22l8.606-8.723a.751.751,0,0,0-.007-1.061A.746.746,0,0,0,9.876-32,.747.747,0,0,0,9.342-31.777Z" transform="translate(0 32)" fill="#00D991" />
      </svg>
    </span>
  )
}

const NextArrow = ({ onClick, style, className }) => {
  let attr = { onClick, style, className }
  return (
    <span
      {...attr}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="10.625" height="20" viewBox="0 0 10.625 20">
        <path d="M9.342.223.216,9.473a.751.751,0,0,0,0,1.054l9.126,9.25a.75.75,0,1,0,1.067-1.054L1.8,10l8.606-8.723A.75.75,0,1,0,9.342.223Z" transform="translate(10.625 20) rotate(180)" fill="#00d991" />
      </svg>
    </span>
  )
}

const Gallery = ({ gallery }) => {

  const [slideIndex, setSlideIndex] = React.useState(0)

  const settings = {
    speed: 600,
    fade: true,
    autoplay: true,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    cssEase: 'ease',
    swipe: false,
    focusOnSelect: false,
    adaptiveHeight: true,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (current, next) => setSlideIndex(next + 1)
  }

  return (
    <section className='gallery'>
      <Fade bottom distance={'40px'}>
        <div className='gallery__inner'>
          {gallery?.length > 0 &&
            <BlockUpdate>
              <Slider {...settings}>
                {gallery?.map((el, i) => (
                  <div className='gallery__item' key={i}>
                    {el.localFile && <GatsbyImage image={getImage(el.localFile)} alt={el.altText ? el.altText : 'Headland Technology'} />}
                  </div>
                ))}
              </Slider>
            </BlockUpdate>
          }
          <div className='gallery__caption'>
            {gallery[slideIndex]?.caption && parse(gallery[slideIndex].caption)}
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default Gallery